import * as types from '../actiontypes';
export function getUserPreferences(url, resource) {
	return {
		type: types.GET_USER_PREFERENCES,
		meta: {
			api: {
				url: url,
				method: 'GET',
				data: {resource: resource}
			}
		}
	};
}

// TODO: DELETE
export function setTheme(isDark) {
	return {
		type: 'SET_USER_THEME',
		isDark: isDark
	};
}

export function updateIsPreferencesLoaded(isPreferencesLoaded) {
	return {
		type: types.SET_IS_PREFERENCES_LOADED,
		isPreferencesLoaded: isPreferencesLoaded
	};
}
